const initialState = {
    perfCityList : [],
    AllCollegeList:[],
    corporateList:[],
    CollegeList:[],
    promotionData:[]
}
export default (state = initialState, action) => {
    switch (action.type) {
      case 'SET_LIST_OF_PERF_CITY':
        return {
          ...state,
          perfCityList: action.data,
        }
        case 'SET_PROMOTION_DATA':
      return {
        ...state,
        promotionData: action?.data,
      }

      case 'SET_LIST_OF_COLLEGE_DATA':
        return {
          ...state,
          AllCollegeList: action.data
        }  

      case 'SET_CORPORATE_MASTER_LIST':
          return {
            ...state,
            corporateList: action.data,
          }

          case 'SET_COLLEGE_LIST':
            return {
              ...state,
              CollegeList: action.data,
            }
    
  
      default:
        return state
    }
  }
  